<template>
  <div class="business-manager">
    <div class="business-manager.header">
      <!-- <el-button
        type="primary"
        class="exportOut"
        icon="el-icon-download"
        @click="exportOut"
      >导出</el-button>-->
      <el-popover placement="bottom" width="300" v-model="visible">
        <el-date-picker
          style="width: 100%"
          v-model="times"
          type="daterange"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
        <div style="text-align: right; margin-top: 10px">
          <el-button
            size="mini"
            type="text"
            @click="
              () => {
                visible = false;
                times = null;
              }
            "
          >
            取消
          </el-button>
          <el-button type="primary" size="mini" @click="exportOut">确定</el-button>
        </div>
        <el-button
          class="exportOut"
          style="margin-left: 10px"
          slot="reference"
          type="primary"
          icon="el-icon-download"
        >
          导出
        </el-button>
      </el-popover>
      <el-input
        placeholder="请输入姓名或电话"
        v-model="searchValue"
        class="input-with-select"
        @keyup.enter.native="search"
        clearable
        @clear="search"
      >
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
      <label style="margin-right: 10px; min-width: 60px; line-height: 40px">审核状态:</label>
      <el-select v-model="statusVal" placeholder="请选择" @change="search">
        <el-option label="全部" value></el-option>
        <el-option label="初审通过" :value="1"></el-option>
        <el-option label="初审未通过" :value="2"></el-option>
        <el-option label="待初审" :value="3"></el-option>
        <el-option label="材料已上传" :value="21"></el-option>
        <el-option label="复审未通过" :value="5"></el-option>
        <el-option label="复审通过" :value="6"></el-option>
      </el-select>
      <label style="margin-right: 10px; line-height: 40px; min-width: 60px">报名来源:</label>
      <el-select
        v-model="srelease"
        clearable
        placeholder="请选择报名来源"
        @change="search"
        style="width: 120px;"
      >
        <el-option label="双平台" :value="1" />
        <el-option label="大市场平台" :value="2" />
        <el-option label="成果交易平台" :value="3" />
      </el-select>
      <el-button type="primary" style="margin-left: 150px" @click="goExpertsManage">
        评估专家
      </el-button>
      <el-button type="success" style="margin-left: 15px" @click="goConsultant">
        顾问团队
      </el-button>
      <el-button type="danger" style="margin-left: 15px" @click="goPersonList">
        往期人员名单
      </el-button>
      <el-button type="warning" style="margin-left: 15px" @click="goClass">课程期数</el-button>
      <el-button type="warning" style="margin-left: 15px" @click="goExperts">行业专家</el-button>
    </div>
    <Table :table="table" :url="url" @editEvent="editEvent" @IDEvent="IDEvent" @fileEvent="fileEvent" ref="children"></Table>
    <el-dialog
      title="技术经纪(经理)人培训"
      :visible.sync="dialogFormVisible"
      :show-close="false"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
    >
      <el-form :model="form" ref="form" label-width="80px">
        <el-row>
          <el-col :span="16">
            <el-form-item label="单位名称">
              <el-input v-model="form.unit" disabled></el-input>
            </el-form-item>
            <div style="display: flex">
              <el-form-item label="学员姓名">
                <el-input v-model="form.contact" disabled></el-input>
              </el-form-item>
              <el-form-item label="性别">
                <el-select v-model="form.sex" disabled>
                  <el-option
                    v-for="item in [
                      { name: '男', key: 1 },
                      { name: '女', key: 2 }
                    ]"
                    :key="item.key"
                    :label="item.name"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div style="display: flex">
              <el-form-item label="证件号码">
                <el-input v-model="form.card" disabled></el-input>
              </el-form-item>
              <el-form-item label="邮箱">
                <el-input v-model="form.email" disabled></el-input>
              </el-form-item>
            </div>
            <div style="display: flex">
              <el-form-item label="手机号码">
                <el-input v-model="form.phone" disabled></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <el-form-item>
              <img v-if="form.portrait" :src="imgUrl + form.portrait" class="avatar" />
              <i v-else class="avatar">暂无</i>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col :span="8">
            <el-form-item label="课程级别" prop="level">
              <el-select v-model="form.level" style="width: 100%" 　clearable disabled>
                <el-option
                  v-for="item in classOPtions"
                  :key="item.courseId"
                  :label="item.courseName"
                  :value="item.courseId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="课程期数">
              <el-select
                v-model="form.course_phase_id"
                placeholder="请选择课程期数"
                disabled
                style="width: 100%"
              >
                <el-option
                  v-for="item in qishuOPtions"
                  :key="item.id"
                  :label="item.course_phase"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
						<el-form-item label="总课时" prop="total_course">
							<el-input v-model="form.total_course" disabled></el-input>
						</el-form-item>
          </el-col>-->
        </el-row>
        <el-row v-if="form.level && form.level != 1">
          <el-col :span="6">
            <el-form-item label="是否选修">
              <el-select v-model="form.selected_electives" disabled>
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          label="选修课程"
          v-if="form.level && form.level != 1 && form.selected_electives == 1"
        >
          <el-checkbox-group
            v-model="form.electives_ids"
            style="width: 100%; display: flex"
            disabled
          >
            <el-checkbox v-for="choose in chooseLists" :label="choose.id" :key="choose.id">
              {{ choose.course_name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="出生年月">
              <el-input v-model="form.birth_date" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="民族">
              <el-input v-model="form.nation" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="最高学历">
              <el-input v-model="form.education_background" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="参加工作时间" label-width="120px">
              <el-date-picker
                v-model="form.start_career_datetime"
                type="year"
                placeholder="选择年"
                :value-format="'yyyy'"
                disabled
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="职务">
              <el-input v-model="form.job" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="职称">
              <el-input v-model="form.job_title" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="邮编">
              <el-input v-model="form.post_code" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="传真">
              <el-input v-model="form.fax" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col :span="24">
            <el-form-item label="工作简历">
              <el-input
                type="textarea"
                :autosize="{ minRows: 6, maxRows: 6 }"
                v-model="form.remark"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="地址">
          <el-cascader
            size="large"
            :options="addroptions"
            v-model="form.address_prefix"
            style="width: 100%"
            clearable
            disabled
          ></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input style="width: 100%" v-model="form.address" clearable disabled>
            <template slot="append">邮寄证书和发票的地址</template>
          </el-input>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="审核" prop="status" style="width: 100%">
              <el-select style="width: 100%" v-model="form.status" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                  :disabled="item.disabled"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-show="form.file.length > 0">
            <el-form-item
              label="用户上传的材料:"
              prop="learn_duration"
              style="width: 100%"
              label-width="120px"
            >
              <div style="display: flex; flex-direction: column">
                <a
                  class="handle"
                  :href="imgUrl + item.url"
                  v-for="(item, index) in form.file"
                  target="_blank"
                  :key="index"
                >
                  {{ item.name }}
                </a>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="补正意见" prop="suggest">
          <el-input
            type="textarea"
            :autosize="{ minRows: 6, maxRows: 6 }"
            placeholder="请输入内容..."
            v-model="form.suggest"
          ></el-input>
        </el-form-item>
        <el-form-item style="text-align: center">
          <el-button @click="close('form')">取消</el-button>
          <el-button type="primary" @click="submit('form')" :loading="loading">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- <el-dialog title="本地课程详情" :visible.sync="dialogClass" :show-close="false" :modal-append-to-body="false" width="600px">
			<div class="class-box">
				 <el-checkbox-group v-model="checkedClass">
				    <el-checkbox v-for="(item,index) in classes" :label="item.id" :key="index">
						<span>{{item.name}}</span>
						 <el-input placeholder="请输入课程期数" v-model="item.input" type="number" :disabled="checkedClass[index] != item.id" clearable>
						    <template slot="prepend">课程期数</template>
						  </el-input>
					</el-checkbox>
				  </el-checkbox-group>
				  <div style="text-align:right;margin-top: 20px;">
						<el-button @click="cancelClass">取消</el-button>
						<el-button type="primary" @click="submitClass">确认</el-button>
				  </div>
			</div>
    </el-dialog>-->
  </div>
</template>

<script>
import Table from './table.vue';
import { regionData } from 'element-china-area-data';
import { SendSiteMessage, SendMessage, GetFileName, FunDownload } from '../../../utils/tool'
export default {
  components: {
    Table
  },
  data() {
    return {
      expert: '', //行业专家人数
      visible: false,
      times: '',
      loading: false,
      is_submit: true,
      table: {
        columns: [
          {
            prop: 'contact',
            label: '联系人'
          },
          {
            prop: 'phone',
            label: '报名电话'
          },
          {
            prop: 'dateTime',
            label: '报名时间'
          },
          { prop: 'status', label: '审核状态', type: 'status', moreText: true },
          {
            prop: 'remark',
            label: '工作简历',
            class: 'ellipsis-02'
          },
          {
            prop: 'isAchievement',
            label: '报名来源',
            type: 'is_achievement'
          }
        ],
        hasBtn: true,
        hasSelect: false,
        btns: [
          {
            name: '审核',
            event: 'editEvent',
            type: 'success'
          },
          {
            name: '照片',
            event: 'IDEvent',
            type: 'success'
          },
          {
            name: '附件',
            event: 'fileEvent',
            type: 'success'
          }
        ]
      },
      url: 'Technology_Skill?type=4',
      searchValue: '',
      statusVal: '',
      srelease: '',
      dialogFormVisible: false,
      dialogClass: false,
      options: [
        {
          id: 3,
          name: '待审核',
          disabled: true
        },
        {
          id: 1,
          name: '初审通过'
        },
        {
          id: 2,
          name: '初审不通过'
        },
        {
          id: 21,
          name: '材料已上传',
          disabled: true
        },
        {
          id: 5,
          name: '复审未通过'
        },
        {
          id: 6,
          name: '复审已通过'
        }
      ],
      chooseLists: [],
      classOPtions: [],
      qishuOPtions: [],
      total_courses: [
        { name: '初级', course: 24 },
        { name: '中级', course: 16 },
        { name: '高级', course: 16 }
      ],
      courseIndex: 0,
      form: {
        unit: '',
        name: '',
        contact: '',
        sex: 1,
        portrait: '',
        card: '',
        email: '',
        phone: '',
        //code:'',
        level: '',
        course_phase_id: '',
        selected_electives: 1,
        electives_ids: [],
        education_background: '',
        start_career_datetime: '',
        remark: '',
        address_prefix: [],
        address: '',
        id: '',
        status: 3,
        suggest: '',
        total_course: 0, //总课时
        learn_duration: 0, //已完成课时
        birth_date: '', //出生年月
        nation: '', //民族
        job: '', //职务
        job_title: '', //职称
        post_code: '', //邮编
        fax: '', //传真
        file: '' //用户上传的材料
      },
      classes: [
        {
          name: '初级',
          input: '',
          id: 1
        },
        {
          name: '中级',
          input: '',
          id: 2
        },
        {
          name: '高级',
          input: '',
          id: 3
        }
      ],
      checkedClass: [],
      addroptions: regionData
    };
  },
  created() {
    this.expertFn(true);
  },
  methods: {
    // 行业专家提交
    async expertFn(flag = false) {
      if (flag) {
        const res = await this.http.get('/expert_stat/1');
        if (res.code === 0) {
          this.expert = res.data.industry_expert_num;
        }
        return;
      }
      const pam = {
        industry_expert_num: this.expert
      };
      const res = await this.http.put('/expert_stat/1', pam);
      if (res.code === 0) {
        // this.expertFn(true);
        this.$message.success('提交成功');
      }
    },

    //导出
    exportOut() {
      let url = '';
      if (this.times) {
        /*url =
          window.urlConfig.url +
          'Technology_Skill_Export?type=4&time_type=1&start_datetime=' +
          this.times[0] +
          '&end_datetime=' +
          this.times[1];*/
        url = `${urlConfig.devUrl}apij2/admin-api/signature/technology-skill/export-excel?type=4&time_type=1&date=`+this.times
      } else {
        // url = window.urlConfig.url + 'Technology_Skill_Export?type=4';
        url = `${urlConfig.devUrl}apij2/admin-api/signature/technology-skill/export-excel?type=4`
      }
      var a = document.createElement('a');
      a.href = url;
      a.download = '';
      a.click();
      this.visible = false;
      this.times = null;
    },
    getClasses() {
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/voucher/technology-skill-course-phase/tree`, {
        page: 1,
        pageSize: 100
      }).then(res => {
        if (res.code == 0) {
          this.classOPtions = res.data;
        } else {
          this.$message.error('获取数据失败！！');
        }
      });
    },
    goPersonList() {
      this.$router.push({
        path: `/${this.$route.fullPath.split('/')[1]}/business/person`
      });
    },
    goConsultant() {
      this.$router.push({
        path: `/${this.$route.fullPath.split('/')[1]}/business/consultant`
      });
    },
    goExpertsManage() {
      this.$router.push({
        path: `/${this.$route.fullPath.split('/')[1]}/business/expertsManage`
      });
    },
    goPhotoList() {
      this.$router.push({
        path: `/${this.$route.fullPath.split('/')[1]}/business/photo`
      });
    },
    goClass() {
      this.$router.push({
        path: `/${this.$route.fullPath.split('/')[1]}/business/classes`
      });
    },
    goExperts() {
      this.$router.push({
        path: `/${this.$route.fullPath.split('/')[1]}/business/experts`
      });
    },
    cancelClass() {
      this.checkedClass = [];
      this.classes.map(item => {
        item.input = '';
      });
      this.dialogClass = false;
    },
    submitClass() {},
    search() {
      var str = this.srelease
        ? this.srelease === 1
          ? '&isMarket=1&isAchievement=1'
          : this.srelease === 2
          ? '&isMarket=1&isAchievement=2'
          : '&isMarket=2&isAchievement=1'
        : '';
      this.url = `/Technology_Skill?type=4&search=${this.searchValue}&status=${this.statusVal}${str}`;
    },
    IDEvent(row) {
      FunDownload(this.imgUrl + row.portrait);
    },
    fileEvent(row) {
      const fileList = JSON.parse(row.type4_attachment)
      fileList.map(item => {
        FunDownload(this.imgUrl + item.url);
      })
    },
    editEvent(row) {
      this.is_submit = true;
      this.dialogFormVisible = true;
      let key = this.classOPtions.filter(el => el.courseId == row.courseId);
      this.qishuOPtions = key[0].phaseIds;
      this.chooseLists = key[0].phaseIds[0].electives || [];
      this.form.portrait = row.portrait;
      this.form.unit = row.unit;
      this.form.address = row.address;
      this.form.address_prefix = JSON.parse(row.addressPrefix);
      this.form.contact = row.contact;
      this.form.phone = row.phone;
      this.form.sex = row.sex || 1;
      this.form.card = row.card;
      this.form.email = row.email;
      this.form.level = row.courseId;
      this.form.course_phase_id = row.coursePhaseId;
      this.form.electives_ids = row.electivesIds ? row.electivesIds.split(',').map(Number) : [];
      this.form.education_background = row.educationBackground;
      this.form.start_career_datetime = row.startCareerDatetime;
      this.form.remark = row.remark;
      this.form.suggest = row.suggest;
      this.form.status = row.status;
      this.form.id = row.id;
      this.form.selected_electives = row.selectedElectives;
      this.form.birth_date = row.birthDate;
      this.form.nation = row.nation || '暂无';
      this.form.job = row.job || '';
      this.form.job_title = row.jobTitle || '暂无';
      this.form.post_code = row.postCode || '暂无';
      this.form.fax = row.fax || '暂无';
      this.form.user_id = row.userId;
      this.form.file = this.formatFile(row.file);
    },
    close(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    formatFile(files) {
      let arrs = [];
      files &&
        files.split(',').forEach((item, index) => {
          arrs.push({
            name: GetFileName(item),
            url: item
          });
        });
      return arrs;
    },
    // 发送短信验证码
    sendMessage(content, phone) {
      console.log('验证码', content);
      this.http
        .post('code/common_send', {
          content: content,
          phone: phone
        })
        .then(res => {});
    },
    submit(formName) {
      let tip = '';
      let obj = {};
      if (!this.is_submit) return false;
      this.is_submit = false;
      this.$refs[formName].validate(async valid => {
        if (valid) {
          obj.status = this.form.status;
          obj.type = 4;
          if (obj.status == 1 || obj.status == 6) {
            tip = '恭喜您报名的科技人员培训审核通过，请登录平台查看详情。';
          }
          if (obj.status == 2) {
            tip = '很遗憾的通知到您，您报名的科技人员培训未审核通过，请登录平台查看详情。';
          }
          obj.suggest = this.form.suggest;
          obj.userId = this.form.user_id;

          if (obj.status == 6) {
            let title = `您已成功报名${String(new Date().getFullYear())}年第${
              this.form.course_phase_id
            }期${this.classes.filter(d => d.id == this.form.level)[0].name}技术经纪人`;
            let message = `${title}培训班，请登录平台查看详情（详情咨询:  0931-8271700 地址：兰州市高新区雁南路279号科庆综合楼）。`;
            // 发送站内信

            let result = await Promise.all([
              SendSiteMessage({ user_id: obj.user_id, title, message }),
              SendMessage({ content: message, phone: this.form.phone })
            ]);
            console.log('返回结果', result);
            let isNext = true;

            result.forEach(el => {
              if (el?.error?.errmsg) {
                isNext = false;
                this.$message.warning(el?.error?.errmsg);
              }
            });
            if (!isNext) return;
          }
          this.loading = true;
          obj.id = this.form.id;
          this.http
            // .put('Technology_Skill/' + this.form.id, obj)
            .post(`${urlConfig.devUrl}apij2/admin-api/signature/technology-skill/update`, obj)
            .then(res => {
              if (res.code == 0) {
                this.loading = false;
                this.$message.success('审核成功');
                if (obj.status != 3) {
                  this.sendMessage(tip, this.form.phone);
                }
                this.dialogFormVisible = false;
                this.$refs.children.getData(this.url);
              }
            })
            .catch(err => {
              this.is_submit = true;
            });
        } else {
          this.is_submit = true;
        }
      });
    }
  },
  mounted() {
    this.getClasses();
  }
};
</script>

<style lang="scss">
@include component(business-manager) {
  @include part(header) {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    margin-bottom: 20px;

    .el-input {
      width: 200px;
      margin: 0 15px;
    }
  }

  .file-class {
    .el-form-item__content {
      display: flex;
      flex-direction: column;
    }
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
    background-color: grey;
    font-size: 36px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 100%;
    }
  }

  .el-checkbox-group {
    display: flex;

    .el-checkbox {
      text-align: left;

      .el-input {
        margin-left: 15px;
      }
    }
  }
}
.handle:hover {
  color: orangered;
}
</style>
